import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import '../style/style.css';
import updateMain from '../services/Main';
import SuccessMessage from './SuccessMessage';

/* eslint no-underscore-dangle: 0 */
/* eslint prefer-destructuring: ["error", {VariableDeclarator: {object: true}}] */

export default function LogoEdit({ Main }) {
  const [show, setShow] = useState(false);
  let previousLogo = Main[1].image;
  let logo = Main[1].image;

  let succeed = true;

  const saveLogo = (e) => {
    e.preventDefault();

    updateMain(Main[1]._id, logo)
      .catch((err) => {
        succeed = false;
        if (err.response !== undefined) {
          document.getElementById(Main[1]._id).textContent = err.response.data.message;
        }
      })
      .then(() => {
        if (succeed) {
          document.getElementById(Main[1]._id).textContent = null;
          setShow(false);
          previousLogo = logo.filename;
          setShow(true);
        }
      });
  };

  const reset = async (e) => {
    e.preventDefault();
    logo = previousLogo;
    document.getElementById(Main[1]._id).textContent = null;
    document
      .getElementById('logo-image').src = `${process.env.REACT_APP_API_URI}/api/image/${previousLogo}`;
  };

  return (
    <div className="logo-edit" id="editar-logo">
      <Form id="edit-logo">
        <Form.Label className="title mb-1">Alterar Logótipo</Form.Label>
        <hr className="edit-divider" />
        <Form.Group className="mb-3 logo-edit-body">
          <div className="edit-card-pad">
            <img
              id="logo-image"
              className="upload-image"
              src={`${process.env.REACT_APP_API_URI}/api/image/${logo}`}
              alt="logotipo"
              width="235px"
              height="162px"
            />
            <div className="upload-image-div">
              <label className="upload-image-text custom-file-upload">
                <input
                  id="file-input"
                  type="file"
                  onChange={(e) => {
                    document.getElementById('logo-image').src = URL
                      .createObjectURL(e.target.files[0]);
                    logo = e.target.files[0];
                  }}
                />
                Alterar Imagem
              </label>
            </div>
          </div>
        </Form.Group>
        <div>
          <small id={Main[1]._id} className="text-danger pre-wrap logo-edit-body">
            {' '}
          </small>
        </div>
        <div className="d-flex justify-content-md-start justify-content-center logo-edit-body">
          <Button onClick={(e) => saveLogo(e)} variant="principal btn-custom">
            Guardar alterações
          </Button>
          <Button onClick={(e) => reset(e)} variant="cancel btn-custom">
            Cancelar
          </Button>
        </div>
      </Form>
      <SuccessMessage
        show={show}
        setShow={setShow}
        message="O logótipo foi atualizado com sucesso!"
      />
    </div>
  );
}

LogoEdit.propTypes = {
  Main: PropTypes.instanceOf(Object).isRequired,
};
